export interface cv_SocialGroupAccessLevel {
    C_SocialGroupAccessLevel_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    ModifiedBy: string;
    SocialGroupAccessLevel: string;
    SortOrder: number | null;
    Version: number;
}
